import { render, staticRenderFns } from "./ChannelFilter.vue?vue&type=template&id=d916dcb0"
import script from "./ChannelFilter.vue?vue&type=script&lang=js"
export * from "./ChannelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports